import { LocalRoundParams, RoundParams } from 'src/games/common/phaser/model/round-params';
import { LocalDealer } from '../logic/dealer/local-dealer';
import { LocalRoundResultSubmitter } from 'src/games/common/phaser/model/local-round-result-submitter';
import { SolitaireListener } from '../game/solitaire-listener';

export class SolitaireLocalRoundParams extends LocalRoundParams {
  public readonly dealer: LocalDealer;

  constructor(dealer: LocalDealer, localRoundResultSubmitter: LocalRoundResultSubmitter) {
    super(localRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(solitaireListener: SolitaireListener): SolitaireLocalRoundParams {
    return new SolitaireLocalRoundParams(
      LocalDealer.makeRandom(),
      new LocalRoundResultSubmitter(solitaireListener),
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is SolitaireLocalRoundParams {
    return roundParams instanceof SolitaireLocalRoundParams;
  }
}
